import * as React from 'react'
import List from '@mui/material/List'
import ListItemText from '@mui/material/ListItemText'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import DeviceHubOutlinedIcon from '@mui/icons-material/DeviceHubOutlined'
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined'
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined'
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined'
import HomeOutlined from '@mui/icons-material/HomeOutlined'
import { Link, matchRoutes } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import bluehavenDomain from 'lib/utility/BluehavenDomain'
import Projects from 'components/Sidebar/Menu/Projects'
import Reporting from 'components/Sidebar/Menu/Reporting'
import SiteManage from 'components/Sidebar/Menu/SiteManage'
import { renderIfAllowed } from 'lib/authorization/AuthorizeComponent'
import { renderIfAllowedWithElse } from 'lib/authorization/DashboardAccess'
import ListItemIcon from 'components/Sidebar/Styled/ListItemIcon'
import ListItemButton from 'components/Sidebar/Styled/Button'
import ParticipantLink from './ParticipantLink'
import { isMobileView } from 'lib/GlobalConstants'

type SidebarLinksProps = {
  isDrawerVisible: boolean
  handleDropdownCollapse: () => void
}

const SidebarLinks = ({
  isDrawerVisible,
  handleDropdownCollapse,
}: SidebarLinksProps) => {
  const { t } = useTranslation()

  const homeUIRoute = [
    {
      path: '/adm',
    },
  ]

  const isHomeUiSelected = () => {
    return !!matchRoutes(homeUIRoute, location)
  }

  //TODO: Remove the dashbord link while refactoring, also check multiple condition adding for renderView function
  const homeAndDashboardNavigation = () => {
    const newDashoboardLink = (
      <ListItemButton
        to={{ pathname: `/adm` }}
        component={Link}
        key="dashboard"
        data-testid="dashboard"
        selected={isHomeUiSelected()}
      >
        <ListItemIcon selected={isHomeUiSelected()}>
          <HomeOutlined />
        </ListItemIcon>
        <ListItemText primary={t('sidebar.home')} />
      </ListItemButton>
    )
    const oldDashboardLink = renderIfAllowed(
      'dashboard',
      <ListItemButton
        component="a"
        href={`${bluehavenDomain()}/admin/dashboard`}
        key="dashboard"
        data-testid="dashboard"
      >
        <ListItemIcon>
          <DashboardOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary={t('sidebar.dashboard')} />
      </ListItemButton>,
    )

    return renderIfAllowedWithElse(
      'reporting_dashboard_v2',
      newDashoboardLink,
      oldDashboardLink,
    )
  }
  return (
    <List dense={isMobileView}>
      {homeAndDashboardNavigation()}
      <Projects
        isDrawerVisible={isDrawerVisible}
        handleDropdownCollapse={handleDropdownCollapse}
      />
      {renderIfAllowed('participants', <ParticipantLink />)}

      {renderIfAllowed(
        'newsletters',
        <ListItemButton
          href={`${bluehavenDomain()}/admin/newsletters`}
          component="a"
          key="newsletters"
          data-testid="newsletters"
        >
          <ListItemIcon>
            <MailOutlineOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary={t('sidebar.newsletters')} />
        </ListItemButton>,
      )}

      <Reporting
        isDrawerVisible={isDrawerVisible}
        handleDropdownCollapse={handleDropdownCollapse}
      />

      {renderIfAllowed(
        'team',
        <ListItemButton
          href={`${bluehavenDomain()}/admin/people/administrators`}
          component="a"
          key="team"
          data-testid="team"
        >
          <ListItemIcon>
            <PeopleOutlineOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary={t('sidebar.team')} />
        </ListItemButton>,
      )}

      <SiteManage
        isDrawerVisible={isDrawerVisible}
        data-testid="site-management"
        handleDropdownCollapse={handleDropdownCollapse}
      />
      {renderIfAllowed(
        'appearance',
        <ListItemButton
          href={`${bluehavenDomain()}/admin/sites/editors/home-page`}
          component="a"
          key="appearance"
          data-testid="appearance"
        >
          <ListItemIcon>
            <PaletteOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary={t('sidebar.appearance')} />
        </ListItemButton>,
      )}

      {renderIfAllowed(
        'hubs',
        <ListItemButton
          href={`${bluehavenDomain()}/admin/site_hubs`}
          component="a"
          key="hubs"
          data-testid="hubs"
        >
          <ListItemIcon>
            <DeviceHubOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary={t('sidebar.hubs')} />
        </ListItemButton>,
      )}

      {renderIfAllowed(
        'site_settings',
        <ListItemButton
          component={'a'}
          href={`${bluehavenDomain()}/admin/sites/settings`}
          key="siteSettings"
          data-testid="site-settings"
        >
          <ListItemIcon>
            <SettingsOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary={t('sidebar.siteSettings')} />
        </ListItemButton>,
      )}
      <ListItemButton
        key="marketplace"
        data-testid="marketplace"
        component="a"
        href={`${bluehavenDomain()}/admin/marketplace`}
      >
        <ListItemIcon>
          <StorefrontOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary={t('sidebar.marketplace')} />
      </ListItemButton>
    </List>
  )
}

export default SidebarLinks
